const sampleVariables = `{
   "arrive_time":"8AM",
   "caps_day_of_week":"Tomorrow",
   "check_in_url":"zpty.us/dLyH8",
   "confirmed_appointment_start_time":"9AM",
   "customer_facing_name": "Service Shop USA",
   "day_of_week":"tomorrow",
   "first_name":"John",
   "has_fair_poor_or_danger": true,
   "has_pending_upsells": true,
   "has_poor_or_danger": false,
   "health_check_hosted_url":"zpty.us/02BDN",
   "health_check_filename":"2017-03-23-5084698770407424.html",
   "is_at_home_service": true,
   "is_total_nonzero": true,
   "last_name":"Smith",
   "leave_time":"5PM",
   "location":"Hypertherm",
   "make":"Ford",
   "model":"Focus",
   "service_date":"Thursday, March 23",
   "vehicle_string":"Green 2010 Ford Focus ",
   "approve_services_url":"https://zippity-app-staging.herokuapp.com/approve-services/5934195385827328/5084698770407424"
}`;

export default sampleVariables;
